import { ShieldCheck } from 'lucide-react';

/** Bare logo icon for callers that draw their own tile; size and color come from className. */
export function LogoGlyph({ className }: { className?: string }) {
  return <ShieldCheck className={className} strokeWidth={2.4} />;
}
